import {
    useEffect,
    useState
} from "react";
import {
    supabase
} from "../lib/util";

export const useAuth = () => {
    const [user, setUser] = useState({});
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [sessionData, setSessionData] = useState({})
    const addUserToDatabase = async (email) => {
        try {
            const {
                data: userData,
            } = await supabase
                .from('UserData')
                .select("email")
                .eq("email", email)
                .single();


            if (userData) {
                localStorage.setItem("isAdded",true)
                throw new Error("This email has been already registered");
            }

             const {
                data: insertData,
                 error: insertError
             } = await supabase
                 .from("UserData")
                 .insert([{
                     email
                 }]);
             if (insertError) throw insertError;

             if(insertData){
                localStorage.setItem("isAdded",true)
             }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        // Listen for auth state change
        const {
            data: {
                subscription = {}
            }
        } = supabase.auth.onAuthStateChange(async (_event, session) => {
            setUser(session?.user || {});
            setIsAuthenticated(session?.access_token !== undefined);
            const isAdded = localStorage.getItem("isAdded") ?? false;
            if (_event === "SIGNED_IN" && session && (session?.access_token !== sessionData?.access_token) && !isAdded) {
                const email = session?.user?.email;
                await addUserToDatabase(email);
            }
            setSessionData(session)
        });

        return () => subscription.unsubscribe();
        // eslint-disable-next-line
    }, []);

    return {
        user,
        isAuthenticated
    }
}